/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import ApiService from 'cio/services/api';
import ApiCredentialModel from 'cio/models/api-credential';
import ApiErrorsService from 'cio/services/api-errors';
import AccountService from 'cio/services/account';
import { IntegrationSnippetType } from 'cio/utils/analytics/transforms/integrations';
import { getFormsHostForDataCenter } from 'cio/utils/data-centers';
import { getApiHost } from 'cio/utils/data-centers';

interface JsSnippetArgs {
  credentials: ApiCredentialModel;
  onCopy: (type: IntegrationSnippetType) => unknown;
}

export default class JsSnippet extends Component<JsSnippetArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service account!: AccountService;

  @action
  onCopy(type: IntegrationSnippetType) {
    this.args.onCopy(type);
  }

  get apiBaseURL() {
    return getFormsHostForDataCenter(this.account.current?.dataCenter) ?? '';
  }

  get snippet() {
    return `
<script type="text/javascript">
  var _cio = _cio || [];
  (function() {
      var a,b,c;a=function(f){return function(){_cio.push([f].
      concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
      "sidentify","track","page"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
      var t = document.createElement('script'),
          s = document.getElementsByTagName('script')[0];
      t.async = true;
      t.id    = 'cio-tracker';
      t.setAttribute('data-site-id', '${this.args.credentials.siteId ?? 'siteid'}');
      t.setAttribute('data-use-array-params', 'true');

      // To disable in-app messages, set this to false
      t.setAttribute('data-use-in-app', 'true');

      t.src = 'https://assets.customer.io/assets/${getApiHost('track', this.account.current?.dataCenter ?? '')}.js';

      s.parentNode.insertBefore(t, s);
  })();
</script>
    `.trim();
  }
}
